import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_NAME = "inactive-questions-modal";

const keys = addTranslations(RESOURCE_NAME, {
    inactive_questions_modal_title: {
        en: "Non relevant questions",
        fr: "Questions non pertinentes",
    },
    table_empty_state_title: {
        en: "No non relevant questions found",
        fr: "Aucune question non pertinente trouvée",
    },
    table_empty_state_subtitle: {
        en: "Modify your filters or add questions",
        fr: "Modifiez vos filtres ou ajoutez des questions",
    },
    table_search_bar_placeholder: {
        en: "Search questions",
        fr: "Rechercher des questions",
    },
    table_header_group: {
        en: "Group",
        fr: "Groupe",
    },
    table_header_name: {
        en: "Name",
        fr: "Nom",
    },
    question_table_action_set_relevant_success: {
        en: "Questions set as relevant",
        fr: "Questions marquées comme pertinentes",
    },
    question_table_action_set_relevant_error: {
        en: "Error setting questions as relevant",
        fr: "Erreur lors du marquage des questions comme pertinentes",
    },
    question_table_action_set_relevant: {
        en: "Set as relevant ({{count}})",
        fr: "Marquer comme pertinent ({{count}})",
    },
    question_table_action_apply: {
        en: "Apply",
        fr: "Appliquer",
    },
});
export function useInactiveQuestionsModalTranslations() {
    const { t } = useTranslation(RESOURCE_NAME);
    return { t, keys };
}
